import { render, staticRenderFns } from "./settingSynchroCard.vue?vue&type=template&id=21ccc4b2&"
import script from "./settingSynchroCard.vue?vue&type=script&lang=js&"
export * from "./settingSynchroCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports